const Valid = (props) => (
  <svg viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M18.737 9.49A9.248 9.248 0 1 1 .241 9.488a9.248 9.248 0 0 1 18.496 0z"
        fill="currentColor"
      />
      <path
        stroke="#fff"
        strokeWidth="2"
        d="M14.253 5.806L8.45 13.12 4.486 9.643"
      />
    </g>
  </svg>
)

export default Valid
